import { render, staticRenderFns } from "./IconMegaphone.vue?vue&type=template&id=6139590d"
import script from "./IconMegaphone.vue?vue&type=script&lang=js"
export * from "./IconMegaphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports